import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import scrollToTop from "../../utils/scrollToTop";

// React Router konumu koruduğu için, uzun bir sayfada aşağı kaydırıp başka sayfaya
// geçildiğinde yeni sayfa aynı kaydırma konumunda (ortasından) açılıyordu. Bu bekçi
// her YOL değişiminde başa döner.
//
// `search`/`hash` DEĞİŞİMİ BİLEREK KAPSAM DIŞI: aynı sayfadaki sekme/filtre/modal
// bağlantıları sorgu dizesini değiştiriyor; onlarda da başa dönmek kullanıcıyı
// bulunduğu yerden koparırdı.
//
// useLayoutEffect: boyamadan ÖNCE sıfırlanır, yani eski konumun bir kare görünmesi olmaz.
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    scrollToTop();
  }, [pathname]);

  return null;
}
